import {
  MonitoredState,
  MonitoredStateCreateRequest,
  MonitoredStateUpdateRequest,
} from '../../types/app/monitoredState.types';
import { api } from '../core/api';

export const getMonitoredStatesByDep = (departmentId: number) =>
  api
    .get<MonitoredState[]>(`MonitoredState/GetList/?parentId=${departmentId}`)
    .then((res) => res.data);

export const getMonitoredState = (id: number) =>
  api.get<MonitoredState>(`MonitoredState/GetItem/?id=${id}`).then((res) => res.data);

export const updateMonitoredState = (data: MonitoredStateUpdateRequest) =>
  api.put(`MonitoredState/UpdateItem`, data).then((res) => res.data);

export const createMonitoredState = (data: MonitoredStateCreateRequest) =>
  api.post(`MonitoredState/CreateItem`, data).then((res) => res.data);

export const deleteMonitoredState = (id: number) =>
  api.delete<MonitoredState>(`MonitoredState/DeleteItem/?id=${id}`).then();

export const getCount = (parentId?: number) =>
  api
    .get<number>(`MonitoredState/GetCount` + (parentId ? `?parentId=${parentId}` : ''))
    .then((res) => res.data);
